import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n/config';
import { CartProvider } from "./contexts/CartContext";
import { WishlistProvider } from "./contexts/WishlistContext";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";

const queryClient = new QueryClient();

// Remove loading skeleton when React starts rendering
const rootElement = document.getElementById("root")!;
const skeleton = rootElement.querySelector("#loading-skeleton");
if (skeleton) skeleton.remove();

// Auto-recover from stale lazy-loaded chunks after a redeploy
window.addEventListener("vite:preloadError", () => {
  if (!sessionStorage.getItem("chunk-reloaded")) {
    sessionStorage.setItem("chunk-reloaded", "1");
    window.location.reload();
  }
});
window.addEventListener("error", (e) => {
  const msg = String(e?.message || "");
  if (msg.includes("dynamically imported module") && !sessionStorage.getItem("chunk-reloaded")) {
    sessionStorage.setItem("chunk-reloaded", "1");
    window.location.reload();
  }
});

createRoot(rootElement).render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <WishlistProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </WishlistProvider>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </HelmetProvider>
);
